// extracted by mini-css-extract-plugin
export default {"icon":"ErpSyncButton_icon__f0XKN"};